export default __webpack_public_path__ + "static/media/storageUnit1-afterC-2048w.6a10ff1e.webp";